import Flex from '@deprecated-ui/common/Flex';
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import { PopoverContainer, NavbarWeb as Navbar } from '@deprecated-ui/header';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const PopoverNavbarContainer = styled(PopoverContainer)`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: unset;
  border: none;
  overflow-y: auto;
  background-color: white;
`;

const IconClose = styled(IconWrapper)`
  position: relative;
  border-right: 1px solid ${color.midgray};

  ::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 1px;
    top: 100%;
    background: ${color.light};
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-left: 1px solid ${color.downgray};
`;

const LogoExpand = styled.div<{ size?: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  & > span {
    display: inline-block;
    height: 1px;
    background: ${color.midgray};
  }
`;

const NavigationMobile = styled(Flex).attrs({
  direction: 'column',
  py: '15px',
  align: 'center',
  justify: 'center',
})`
  border-bottom: 1px solid ${color.downgray};
  border-right: 1px solid ${color.downgray};
`;

const NavbarWeb = styled(Navbar)`
  padding-right: 0;
  background-color: white;
  border-top-color: ${color.gainsboro};

  div:nth-child(2) {
    :nth-child(2) {
      background: ${color.light};
      border-top: none;
    }
  }
`;

const Navigation = styled(Flex)
  .withConfig({
    shouldForwardProp: (prop) => !['active'].includes(prop as string),
  })
  .attrs((props) => ({
    // @ts-expect-error
    active: props.active,
    align: 'center',
    p: '14px',
  }))`
    height : 40px;
    background-color: white;
    color : ${({ active }) => (active ? color.primary : '#858585')};

    @media only screen and (min-width: 1917px) and (max-width: 1940px){
      padding: 12px;
    } 

    @media only screen and (min-width: 2040px) {
      padding: 13px;
    } 

    
    :hover,
    a:hover{
      color : ${({ active }) => (active ? color.primary : color.highempahis)};
    }
  `;

const NavLink = styled.a`
  color: inherit;
  display: flex;
  align-items: center;
`;

export {
  PopoverNavbarContainer,
  IconClose,
  Grid,
  LogoExpand,
  NavigationMobile,
  NavbarWeb,
  Navigation,
  NavLink,
};
